module.exports = __webpack_public_path__ + "icone-pdf.png?370c69248fa731bb2ce56dfd7b3dc767";